module.exports = __webpack_public_path__ + "static/media/wqu.e766e6b8.png";